import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkIcon from '@mui/icons-material/Link';
import { Toolbar, Typography, Link, IconButton, Container, Box, useTheme, AppBar, } from '@mui/material';
export function Footer() {
    const theme = useTheme();
    return (_jsx(AppBar, Object.assign({ position: "relative", elevation: 0 }, { children: _jsx(Toolbar, Object.assign({ component: "footer", sx: { backgroundColor: theme.palette.background.paper } }, { children: _jsxs(Container, Object.assign({ sx: {
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    textAlign: { xs: 'center', sm: 'left' },
                } }, { children: [_jsxs(Typography, Object.assign({ variant: "body2", color: "textSecondary", sx: {
                            marginBottom: { xs: '10px', sm: '0' },
                            width: { xs: '100%', sm: 'auto' },
                        } }, { children: ["\u00A9 ", new Date().getFullYear(), " Gago.Works. All rights reserved."] })), _jsxs(Box, Object.assign({ sx: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            mr: '24px',
                        } }, { children: [_jsxs(Link, Object.assign({ href: "https://gago.works", target: "_blank", rel: "noopener noreferrer", "aria-label": "Visit Gago.Works", sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    textDecoration: 'none',
                                    marginRight: '10px',
                                } }, { children: [_jsx(IconButton, Object.assign({ color: "inherit" }, { children: _jsx(LinkIcon, {}) })), "Gago.Works"] })), _jsxs(Link, Object.assign({ href: "https://github.com/gagovictor", target: "_blank", rel: "noopener noreferrer", "aria-label": "Visit GitHub profile", sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    textDecoration: 'none',
                                } }, { children: [_jsx(IconButton, Object.assign({ color: "inherit" }, { children: _jsx(GitHubIcon, {}) })), "GitHub"] }))] }))] })) })) })));
}
